export const VerifyEmailPageConstants = {
  PageTitle: 'Help us locate your transaction',
  PageParagraph:
    'Provide your email address below and we’ll locate any products or subscriptions you’ve purchased from our sellers *',
  DisclaimerParagraph: '* We promise never to store or use the email address you provide for any other purpose',
} as const
